/* eslint-disable no-restricted-globals */
/* eslint-disable camelcase */
/* eslint-disable import/order */
/* eslint-disable no-nested-ternary */
/* eslint-disable new-cap */
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  notification, Drawer, Popconfirm, Dropdown, Menu,
} from 'antd';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import Constants, { S3_FILE_URL, toISTDate } from '@Apis/constants';
import {
  LoadingOutlined, EditOutlined, CaretRightOutlined, FilePdfOutlined, CaretDownOutlined,
} from '@ant-design/icons';
import Helpers from '@Apis/helpers';
import GrnActions from '@Actions/grnActions';
import BulkPOActions from '@Actions/purchase/purchaseOrders/bulkPOActions';
import closeIcon from '@Images/icons/icon-close-blue.png';
import './style.scss';
import UserActions from '@Actions/userActions';
import Attachment from '@Components/Common/Attachment';
import AttachmentActions from '@Actions/attachmentActions';
import ViewCustomFields from '@Components/Common/CustomField/ViewCustomFields';
import ZohoIntegrationActions from '@Actions/integrations/zohoIntegrationActions';
import BulkPOLines from './BulkPOLines';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.bubble.css';

/**
 *
 */
class ViewBulkPO extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      dateList: [],
      showCheckout1: false,
      showCheckout2: false,
      showCheckout3: false,
      poPaid: false,
      isUserReady: false,
      currentUpdate: '',
      isGetAttachment: false,
    };
  }

  /**
   *
   */
  componentDidMount() {
    const {
      getBulkPOById, user, match,
    } = this.props;
    getBulkPOById(user?.tenant_info?.org_id, 'view', match?.params?.bulkPoId);
  }

  /**
     *
     */
  componentWillUnmount() {
    const {
      getBulkPOByIdSuccess,
    } = this.props;
    getBulkPOByIdSuccess(null);
  }

  /**
   *
   * @param props
   * @param state
   * @return {{isUserReady}|*|(*&{isUserReady: boolean})}
   */
  static getDerivedStateFromProps(props, state) {
    if (props?.selectedBulkPO && !state.isUserReadyForPrefillData) {
      const selectedBulkPO = props?.selectedBulkPO;
      return {
        ...state,
        fileList: selectedBulkPO?.attachments,
        isUserReadyForPrefillData: true,
      };
    }
    if (props?.selectedAttachment && state.isGetAttachment && !state.getAttachmentByIdLoading && !state.updateAttachmentLoading) {
      return {
        ...state,
        fileList: props?.selectedAttachment,
        isGetAttachment: false,
      };
    }

    return state;
  }

  /**
   * @param fileListData
   */
  handleFileChange(fileListData) {
    const { updateAttachment, selectedBulkPO, getAttachmentById } = this.props;

    const fileList = fileListData?.fileList?.map((item) => ({
      ...item,
      url: item?.response?.response?.location || item?.url,
    }));

    const attachments = fileList?.map((attachment) => ({
      url: attachment?.response?.response?.location || attachment?.url, type: attachment.type, name: attachment.name, uid: attachment.uid,
    }));

    if (fileListData?.file.status === 'done') {
      const payload = {
        entity_id: selectedBulkPO?.po_id,
        entity_name: 'purchase_order',
        attachments,
      };
      updateAttachment(payload, () => {
        getAttachmentById(selectedBulkPO?.po_id, 'purchase_order', () => {
          this.setState({
            isGetAttachment: true,
          });
        });
      });
    }
    if (fileListData?.file.status === 'removed') {
      const payload = {
        entity_id: selectedBulkPO?.po_id,
        entity_name: 'purchase_order',
        attachments,
      };
      updateAttachment(payload, () => {
        getAttachmentById(selectedBulkPO?.po_id, 'purchase_order', () => {
          this.setState({
            isGetAttachment: true,
          });
        });
      });
    }

    this.setState({
      fileList: attachments.length > 0 ? attachments : [],
    });
  }

  convertToView() {
    const { selectedBulkPO } = this.props;
    if (selectedBulkPO?.linked_pos) {
      const data = JSON.parse(JSON.stringify(selectedBulkPO?.linked_pos));
      const uniqueProductSkuIDs = [...new Set(data?.map((po) => po.po_lines.map((po_line) => po_line.product_sku_id)).flat())];
      const products = [];
      uniqueProductSkuIDs.map((product_sku_id) => {
        const productObject = {};
        const posOfProduct = [];
        for (let i = 0; i < data.length; i++) {
          const po = data[i];
          const { po_lines } = po;
          const productPoLines = po_lines.find((po_line) => po_line.product_sku_id === product_sku_id);
          if (productPoLines) { posOfProduct.push(po); }
        }
        const firstPoLine = posOfProduct[0].po_lines.find((poLine) => poLine?.product_sku_id === product_sku_id);
        productObject.product_sku_name = firstPoLine.product_sku_name;
        productObject.internal_sku_code = firstPoLine.internal_sku_code;
        productObject.product_sku_id = firstPoLine.product_sku_id;
        productObject.tax_id = firstPoLine.tax_id;
        productObject.tax_info = firstPoLine.tax_info;
        productObject.uom_id = firstPoLine.uom_id;
        productObject.uom_info = firstPoLine.uom_info;
        const tenantProducts = [];

        for (let j = 0; j < posOfProduct.length; j++) {
          const currentProductSkuId = posOfProduct[j].po_lines.find((poLine) => poLine?.product_sku_id === product_sku_id);
          const tenantObject = {};
          tenantObject.tenant_info = posOfProduct[j].tenant_info;
          tenantObject.quantity = currentProductSkuId.quantity;
          tenantObject.total_price = currentProductSkuId.total_price;
          tenantProducts.push(tenantObject);
        }
        productObject.tenants = tenantProducts;
        products.push(productObject);
      });

      return products;
    }
    return [];
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      user,
      getBulkPOByIdLoading, getBulkPOById, selectedBulkPO,
      MONEY, match, history, updateBulkPOStatus, updateBulkPOStatusLoading,
    } = this.props;
    const {
      showNewGrnForm, fileList, currentUpdate,
    } = this.state;
    return (
      <div className={window.location.href.includes('/bulk-purchase-orders/view') ? 'view-bulk-po__wrapper-page' : 'view-bulk-po__wrapper'}>
        {!(getBulkPOByIdLoading)
          ? (
            <div className="ant-row">
              <div className="ant-col-md-16 ant-col-xs-24">
                <div className="vq__wrapper bulk-po__wrapper">
                  <div className="vq__header">
                    <div className="vq__header-left">
                      <div className="vq__header-field">
                        <H3Text text="PO Number#" className="vq__header-field-name" />
                        <H3Text text={selectedBulkPO?.blanket_po_no ? selectedBulkPO.blanket_po_no : '-'} className="vq__header-field-value" />
                      </div>
                      <div className="vq__header-field">
                        <H3Text text="PO Date" className="vq__header-field-name" />
                        <H3Text
                          text={selectedBulkPO?.linked_pos?.[0]?.po_date ? (toISTDate(selectedBulkPO?.linked_pos?.[0]?.po_date).format('DD/MM/YYYY')) : '-'}
                          className="vq__header-field-value"
                        />
                      </div>
                      <div className="vq__header-field">
                        <H3Text text="Created By" className="vq__header-field-name" />
                        <H3Text
                          text={selectedBulkPO?.created_by_info ? selectedBulkPO?.created_by_info : '-'}
                          className="vq__header-field-value"
                        />
                      </div>
                      {selectedBulkPO?.custom_fields ? (
                        <ViewCustomFields
                          customFields={selectedBulkPO?.custom_fields}
                          wrapperClass="vq__header-field"
                          labelClass="vq__header-field-name"
                          valueClass="vq__header-field-value"
                        />
                      ) : ''}
                    </div>
                    <div className="vq__header-right__wrapper">
                      <div className="view-bulk-po__status" style={{ color: Helpers.getStatusColor(selectedBulkPO?.status).color }}>
                        {selectedBulkPO?.status?.replaceAll('_', ' ')}
                      </div>
                      {window.location.href.includes('/bulk-purchase-orders/view') && (
                        <div className="vq__header-right">
                          <div className="action-buttons view__bulk-po-menu">
                            {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.UPDATE, user)
                            && selectedBulkPO?.status === 'DRAFT' && (
                              <H3Text
                                text={(
                                  <div onClick={() => {
                                    history.push(`/purchase/bulk-purchase-orders/update/${selectedBulkPO?.blanket_po_id}`);
                                  }}
                                  >
                                    <EditOutlined />
                                  </div>
                                )}
                                className="action-button"
                              />
                            )}
                            <Dropdown
                              overlay={(
                                <div style={{ width: '190px' }}>
                                  <Menu>
                                    <Menu.Item>
                                      <H3Text
                                        text="Location Wise PO(s)"
                                        onClick={() => window.open(`${Constants.BULK_PO}/download?blanket_po_id=${selectedBulkPO?.blanket_po_id}&org_id=${user?.tenant_info?.org_id}&type=download`)}
                                      />
                                    </Menu.Item>
                                    <Menu.Item>
                                      <H3Text
                                        text="Planned Purchase Order"
                                        onClick={() => window.open(`${Constants.BULK_PO}/download?blanket_po_id=${selectedBulkPO?.blanket_po_id}&org_id=${user?.tenant_info?.org_id}&type=download&download_type=single_po`)}
                                      />
                                    </Menu.Item>

                                  </Menu>
                                </div>
                              )}
                              trigger={['click']}
                              placement="bottomRight"
                            >
                              <div className="action-button " onClick={(e) => e.preventDefault()}>
                                <FilePdfOutlined />
                              </div>
                            </Dropdown>
                          </div>
                          <div className="action-buttons">
                            {['DRAFT'].includes(selectedBulkPO?.status) && Helpers.getPermission(Helpers.permissionEntities.PURCHASE_ORDER,
                              Helpers.permissionTypes.CREATE, user) && (
                              <Popconfirm
                                placement="topRight"
                                title="Are you sure you want to confirm this bulk purchase order?"
                                onConfirm={() => {
                                  this.setState({ currentUpdate: 'ISSUED' });
                                  updateBulkPOStatus({
                                    status: 'ISSUED',
                                    blanket_po_id: selectedBulkPO.blanket_po_id,
                                  }, () => {
                                    getBulkPOById(user?.tenant_info?.org_id, 'view', match?.params?.bulkPoId);
                                    this.setState({ sendForApprovalConfirmation: false, currentUpdate: '' });
                                  });
                                }}
                                okText="Yes"
                                cancelText="No"
                              >
                                <H3Text
                                  text={(
                                    <div style={{ width: '100px', textAlign: 'center' }}>
                                      {(updateBulkPOStatusLoading && currentUpdate === 'DRAFT')
                                        ? <LoadingOutlined /> : (
                                          <span>Confirm Order</span>
                                        )}
                                    </div>
                                  )}
                                  onClick={() => this.setState({ sendForApprovalConfirmation: true })}
                                  className="action-button action-button-big"
                                />
                              </Popconfirm>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  { user?.logo && <img alt="logo" src={`${S3_FILE_URL}/${user.logo}`} className="om__status-logo" /> }
                  <div className="vq__billing-wrapper">
                    <div className="ant-row">
                      <div className="ant-col-md-12 ant-col-xs-24">
                        <div className="vq__billed-by">
                          <H3Text text="Vendor Details" className="vq__billed-by-title" />
                          <H3Text text={selectedBulkPO?.linked_pos?.[0]?.tenant_seller_info?.seller_name} className="vq__billed-by-company-name" />
                          {selectedBulkPO?.linked_pos?.[0]?.seller_address && (
                            <H3Text
                              text={selectedBulkPO?.linked_pos?.[0]?.seller_address?.address1}
                              className="vq__billed-by-details"
                            />
                          )}
                          {selectedBulkPO?.linked_pos?.[0] && (
                            <H3Text
                              text={`${selectedBulkPO?.linked_pos?.[0]?.seller_address?.city}, ${selectedBulkPO?.linked_pos?.[0]?.seller_address?.state} ${selectedBulkPO?.linked_pos?.[0]?.seller_address?.postal_code}`}
                              className="vq__billed-by-details"
                            />
                          )}
                          {selectedBulkPO?.linked_pos?.[0]?.tenant_seller_info?.gst_number && (
                            <H3Text
                              text={(
                                <div>
                                  <b>GSTIN: </b>
                                  {selectedBulkPO?.linked_pos?.[0]?.tenant_seller_info?.gst_number}
                                </div>
                              )}
                              className="vq__billed-by-details"
                            />
                          )}
                          {selectedBulkPO?.linked_pos?.[0]?.seller_contact?.email_id_1 && (
                            <H3Text
                              text={(
                                <div>
                                  <b>Email: </b>
                                  {selectedBulkPO?.linked_pos?.[0].seller_contact?.email_id_1}
                                </div>
                              )}
                              className="vq__billed-by-details"
                            />
                          )}
                          {selectedBulkPO?.linked_pos?.[0]?.seller_contact?.mobile_1 && (
                            <H3Text
                              text={(
                                <div>
                                  <b>Phone: </b>
                                  +91-
                                  {selectedBulkPO?.linked_pos?.[0].seller_contact?.mobile_1}
                                </div>
                              )}
                              className="vq__billed-by-details"
                            />
                          )}
                        </div>
                      </div>
                      <div className="ant-col-md-12 ant-col-xs-24">
                        <div className="vq__billed-to">
                          <H3Text text="Billing Address" className="vq__billed-by-title" />
                          {selectedBulkPO?.tenant_info && <H3Text text={selectedBulkPO.tenant_info.tenant_name} className="vq__billed-by-company-name" />}
                          {selectedBulkPO?.tenant_info?.billing_address?.address1 && <H3Text text={selectedBulkPO.tenant_info?.billing_address.address1} className="vq__billed-by-details" />}
                          {selectedBulkPO?.tenant_info?.billing_address?.address1 && (
                            <H3Text
                              text={`${selectedBulkPO?.tenant_info?.billing_address?.city}, ${selectedBulkPO?.tenant_info?.billing_address?.state} ${selectedBulkPO?.tenant_info?.billing_address?.postal_code}`}
                              className="vq__billed-by-details"
                            />
                          )}
                          {selectedBulkPO?.tenant_info?.gst_number && (
                            <H3Text
                              text={(
                                <div>
                                  <b>GSTIN: </b>
                                  {selectedBulkPO.tenant_info.gst_number}
                                </div>
                              )}
                              className="vq__billed-by-details"
                            />
                          )}
                          {selectedBulkPO?.tenant_info?.email && (
                            <H3Text
                              text={(
                                <div>
                                  <b>Email: </b>
                                  {' '}
                                  {selectedBulkPO.tenant_info.email}
                                </div>
                              )}
                              className="vq__billed-by-details"
                            />
                          )}
                          {selectedBulkPO?.tenant_info?.mobile && (
                            <H3Text
                              text={(
                                <div>
                                  <b>Phone: </b>
                                  {' '}
                                  {selectedBulkPO.tenant_info.mobile}
                                </div>
                              )}
                              className="vq__billed-by-details"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <BulkPOLines linkedPOs={this.convertToView() || []} selectedBulkPO={selectedBulkPO} />
                  <div className="view-bulk-po__totals-wrapper">
                    <div className="view__po-footer-left">
                      {selectedBulkPO?.linked_pos?.[0]?.t_and_c && (
                        <div className="view__po-tc">
                          <H3Text text="Terms and Conditions" className="view__po-tc-title" />
                          <div className="view__po-tc-body">
                            <ReactQuill
                              value={selectedBulkPO?.linked_pos?.[0]?.t_and_c ? selectedBulkPO?.linked_pos?.[0]?.t_and_c : ''}
                              readOnly
                              theme="bubble"
                            />
                          </div>
                        </div>
                      )}
                      {/* <Attachment
                        fileList={fileList}
                        disableCase={getAttachmentByIdLoading || updateAttachmentLoading}
                        labelClassName="orgFormLabel"
                        inputClassName=""
                        containerClassName="text-area__po-container"
                        handleFileChange={(value) => this.handleFileChange(value)}
                      /> */}
                    </div>
                    <div className="view-bulk-po__totals">
                      <div className="view-bulk-po__totals-field">
                        <H3Text text="Taxable Amount" className="view-bulk-po__totals-field-name" />
                        <H3Text text={MONEY(selectedBulkPO?.blanket_po_base_price || 0)} className="view-bulk-po__totals-field-value" />
                      </div>
                      <div className="view-bulk-po__totals-field">
                        <H3Text text="Tax" className="view-bulk-po__totals-field-name" />
                        <H3Text text={MONEY(selectedBulkPO?.blanket_po_tax || 0)} className="view-bulk-po__totals-field-value" />
                      </div>
                      {/* <div className="view-bulk-po__totals-field">
                        <H3Text text="Total Amount" className="view-bulk-po__totals-field-name" />
                        <H3Text text={MONEY(selectedBulkPO?.blanket_po_total || 0)} className="view-bulk-po__totals-field-value" />
                      </div> */}
                      {/* <div className="view-bulk-po__totals-field">
                        <H3Text text="Round Off" className="view-bulk-po__totals-field-name" />
                        { selectedBulkPO?.po_round_off < 0
                          ? <H3Text text={`(-) ${MONEY(selectedBulkPO?.po_round_off)}`} className="view-bulk-po__totals-field-value danger-text" />
                          : <H3Text text={` ${MONEY(selectedBulkPO?.po_round_off)}`} className="view-bulk-po__totals-field-value" />}
                      </div> */}
                      <div className="view-bulk-po__totals-field view-bulk-po__totals-field-total">
                        <H3Text text="Payable Amount" className="view-bulk-po__totals-field-name" />
                        <H3Text text={MONEY(selectedBulkPO?.blanket_po_value)} className="view-bulk-po__totals-field-value" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ant-col-md-8 ant-col-xs-24">
                <div className="bulk-po__wrapper__approval">
                  {Helpers.getPermission(Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.READ, user) && window.location.href.includes('/bulk-purchase-orders/view') && selectedBulkPO?.linked_pos?.length > 0 && (
                    <div className="po-grn__wrapper">
                      <H3Text text="PURCHASE ORDERS" className="po-grn__title" />
                      {selectedBulkPO?.linked_pos?.map((item) => (
                        <Link
                          key={item?.po_id}
                          to={`/approval?type=po&id=${item?.po_id}`}
                          target="blank"
                        >
                          <div
                            className="po-grn__item-header"
                          >
                            <CaretRightOutlined />
                            <div>
                              <H3Text text={`PO# ${item?.po_number}`} className="po-grn__item-header-id" />
                              <div style={{ color: 'black' }}>
                                {item?.tenant_info?.tenant_name}
                              </div>
                              <div
                                className="po-grn__item-header-status"
                                style={{ backgroundColor: Helpers.getStatusColor(item?.status)?.color }}
                              >
                                {Helpers.getStatusColor(item?.status)?.text}
                              </div>
                            </div>
                            <H3Text text={MONEY(item?.po_grand_total)} className={`po-grn__item-header-total ${['VOID', 'REJECTED'].includes(item?.status) ? 'po-grn__item-header-total-disabled' : ''}`} />
                          </div>
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )
          : (
            <div style={window.location.href.includes('/approval') ? { marginTop: '100px' } : {}} className="loader__container">
              <div className="loader__container-left">
                <div className="loading-header">
                  {[1, 2, 3, 4].map((item) => (
                    <div key={item} className="loading-header-row">
                      <div className="loading-header__label loadingBlock" />
                      <div className="loading-header__label loadingBlock" />
                    </div>
                  ))}

                </div>
                <div className="loading-address">
                  {[1, 2].map((item) => (<div key={item} className="address loadingBlock" />))}
                </div>
                <div className="loading-table loadingBlock" />
                <div className="loading-header loading-total">
                  {[1, 2, 3, 4].map((item) => (
                    <div key={item} className="loading-header-row">
                      <div className="loading-header__label loadingBlock" />
                      <div className="loading-header__label loadingBlock" />
                    </div>

                  ))}
                </div>
                <div className="loading-header loading-total">
                  <div className="loading-header-row">
                    <div className="loading-header__label loadingBlock" />
                    <div className="loading-header__label loadingBlock" />
                  </div>
                </div>
              </div>
              <div className="loader__container-right">
                {[1, 2, 3].map((item) => (
                  <div key={item} className="loader__container-right-row">
                    <div style={{ display: 'flex' }}>
                      <div className="loader__container-right-row__icon loadingBlock" />
                      <div>
                        <div className="loader__container-right-row__head loadingBlock" />
                        <div className="loader__container-right-row__sub-head loadingBlock" />
                        <div className="loader__container-right-row__sub-head loadingBlock" />
                      </div>
                    </div>
                  </div>
                ))}
              </div>

            </div>
          )}

        <Drawer
          onClose={() => this.setState({ showNewGrnForm: false })}
          open={showNewGrnForm}
          width="1040px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '995px' }}>
              <H3Text text="Create Goods Receiving Note" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showNewGrnForm: false })} />
            </div>
          </div>
        </Drawer>
      </div>
    );
  }
}

const mapStateToProps = ({
  UserReducers, BulkPOReducers, PayoutReducers, GRNReducers, AttachmentReducers, ZohoIntegrationReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  approveApprovePOLoading: BulkPOReducers.approveApprovePOLoading,
  approveRejectPOLoading: BulkPOReducers.approveRejectPOLoading,
  getBulkPOByIdLoading: BulkPOReducers.getBulkPOByIdLoading,
  selectedBulkPO: BulkPOReducers.selectedBulkPO,
  getPoPaymentLoading: PayoutReducers.getPoPaymentLoading,
  updateBulkPOStatusLoading: BulkPOReducers.updateBulkPOStatusLoading,
  updatePoWorkflowStepLoading: BulkPOReducers.updatePoWorkflowStepLoading,
  getGRNLoading: GRNReducers.getGRNLoading,
  grnData: GRNReducers.grnData,
  deleteBulkPOLoading: BulkPOReducers.deleteBulkPOLoading,
  selectedAttachment: AttachmentReducers.selectedAttachment,
  getAttachmentByIdLoading: AttachmentReducers.getAttachmentByIdLoading,
  updateAttachmentLoading: AttachmentReducers.updateAttachmentLoading,
  syncPOLoading: ZohoIntegrationReducers.syncPOLoading,
});

const mapDispatchToProps = (dispatch) => ({
  updatePoStatus: (payload, callback) => dispatch(BulkPOActions.updatePoStatus(payload, callback)),
  deleteBulkPO: (payload, callback) => dispatch(BulkPOActions.deleteBulkPO(payload, callback)),
  updatePoWorkflowStep: (payload, callback) => dispatch(BulkPOActions.updatePoWorkflowStep(payload, callback)),
  getBulkPOById: (orgId, bulkPOType, bulkPOId, callback) => dispatch(BulkPOActions.getBulkPOById(orgId, bulkPOType, bulkPOId, callback)),
  getBulkPOByIdSuccess: (selectedBulkPO) => dispatch(BulkPOActions.getBulkPOByIdSuccess(selectedBulkPO)),
  getGRN: (tenantId, grnId, grnEntityId, grnEntityType, status, limit, page, tenantSellerId) => dispatch(GrnActions.getGRN(tenantId, grnId, grnEntityId, grnEntityType, status, limit, page, tenantSellerId)),
  switchBusinessUnit: (tenantId, callback) => dispatch(UserActions.switchBusinessUnit(tenantId, callback)),
  getAttachmentById: (entityId, entityName, callback) => dispatch(
    AttachmentActions.getAttachmentById(entityId, entityName, callback),
  ),
  updateBulkPOStatus: (payload, callback) => dispatch(BulkPOActions.updateBulkPOStatus(payload, callback)),
  updateAttachment: (payload, callback) => dispatch(
    AttachmentActions.updateAttachment(payload, callback),
  ),
  syncPO: (payload, callback) => dispatch(ZohoIntegrationActions.syncPO(payload, callback)),
});

ViewBulkPO.propTypes = {
  user: PropTypes.any,
  selectedBulkPO: PropTypes.any,
  getBulkPOByIdSuccess: PropTypes.func,
  getBulkPOById: PropTypes.func,
  getBulkPOByIdLoading: PropTypes.bool,
  history: PropTypes.func,
  deleteBulkPOLoading: PropTypes.bool,
  updateBulkPOStatusLoading: PropTypes.bool,
  deleteBulkPO: PropTypes.func,
  updateBulkPOStatus: PropTypes.func,
  updateAttachment: PropTypes.any,
  getAttachmentById: PropTypes.any,
  match: PropTypes.any,
  getAttachmentByIdLoading: PropTypes.any,
  updateAttachmentLoading: PropTypes.any,
  selectedAttachment: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewBulkPO));
